import React, { useEffect } from 'react';
import { Navigate } from 'react-router';
import useAuth from '../../hooks/useAuth';

export default () => {
  const { logout } = useAuth();
  useEffect(() => {
    logout();
  }, []);
  return (
    <Navigate to="/" />
  );
};
